module.exports = __webpack_public_path__ + "media/src/images/hourglass-1d8b6df149f4eeef4dd67d6e1a9007ea.png";